<template>
  <div>
    <v-row>
      <v-col cols="12"><h4> {{ $t('contract.infoSection') }} </h4></v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.area"
          :items="areas"
          outlined
          :label="$tc('contract.area', 1)"
          return-object
          :disabled="areas.length === 1"
          item-text="name"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.project"
          :items="projectsList"
          outlined
          :label="$tc(`contract.project.${form.area.code}`, 1)"
          @change="validationModel.form.project.$touch()"
          :error-messages="errorMessages(this.validationModel.form.project, 'Project')"
          return-object
          item-text="label"
          :disabled="!!form.parentContractId"
          :no-data-text="form.area.code ? $t('common.noData') : $t('common.firstSelectArea')"
        >
          <template v-slot:selection="{ item }">
            {{ item.label }}
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.package"
          :items="packagesList"
          outlined
          :label="$tc('contract.package', 1)"
          @change="validationModel.form.package.$touch()"
          :error-messages="errorMessages(this.validationModel.form.package, 'package')"
          item-value="name"
          :item-text="i => areas.length > 1 ? `${i.name} (${i.area.name})` : i.name"
          :no-data-text="form.area.code ? $t('common.noData') : $t('common.firstSelectArea')"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.contractType"
          :items="typesList"
          outlined
          item-value="name"
          :item-text="i => areas.length > 1 ? `${i.name} (${i.area.name})` : i.name"
          :label="$tc('contract.type', 1)"
          @change="validationModel.form.contractType.$touch()"
          :error-messages="errorMessages(this.validationModel.form.contractType, 'contractType')"
          :no-data-text="form.area.code ? $t('common.noData') : $t('common.firstSelectArea')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="form.contractName"
          :label="$t('contract.name')"
          outlined
          @input="validationModel.form.contractName.$touch()"
          :error-messages="errorMessages(this.validationModel.form.contractName, 'contractName')"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.contractManager"
          :label="$t('contract.contractManager')"
          placeholder="Start typing to search"
          outlined
          :items="graph.contractManager.items"
          :loading="graph.contractManager.isLoading"
          :search-input.sync="search.contractManager"
          hide-no-data
          item-text="displayName"
          item-value="mailNickname"
          @input="validationModel.form.contractManager.$touch()"
          :error-messages="errorMessages(this.validationModel.form.contractManager, 'contractManager')"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.packageManager"
          :label="$t('contract.packageManager')"
          placeholder="Start typing to search"
          outlined
          :items="graph.packageManager.items"
          :loading="graph.packageManager.isLoading"
          :search-input.sync="search.packageManager"
          hide-no-data
          item-text="displayName"
          item-value="mailNickname"
          @input="validationModel.form.packageManager.$touch()"
          :error-messages="errorMessages(this.validationModel.form.packageManager, 'packageManager')"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.projectController"
          :label="$t('contract.projectController')"
          placeholder="Start typing to search"
          outlined
          :items="graph.projectController.items"
          :loading="graph.projectController.isLoading"
          :search-input.sync="search.projectController"
          hide-no-data
          item-text="displayName"
          item-value="mailNickname"
          @input="validationModel.form.projectController.$touch()"
          :error-messages="errorMessages(this.validationModel.form.projectController, 'projectController')"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <!-- <v-row dense class="mb-4">
      <v-col cols="12" class="py-0">
        <h4>
          {{ $t('contract.mainAndSubSection') }}
          <span class="text--secondary font-weight-regular"> {{ $t('common.optional') }}</span>
        </h4>
        <p v-if="form.parts.length > 1" class="text--secondary">{{ $t('contract.mainDisabled') }}</p>
      </v-col>
      <v-col cols="9">
        <v-row align="center">
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="form.parentContract"
              :label="$t('contract.selectMain')"
              :items="potentialParentContractsList"
              item-text="contractName"
              item-value="id"
              outlined
              return-object
              hide-details
              clearable
              @input="handleSelectParent"
              :disabled="form.parts.length > 1"
            >
              <template v-slot:item="{ item }">
                <v-list-item-title v-text="item.contractName" />
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-row align="center" class="mx-1">
              <v-col cols="2" class="pa-0">
                <v-switch
                  v-model="form.isParent"
                  dense
                  :disabled="!!form.parentContractId || form.parts.length > 1"
                />
              </v-col>
              <v-col cols="10" class="pa-0">
                <span class="text--secondary">{{$t('contract.selectAsMain')}}</span>
              </v-col>
            </v-row>
            <span v-if="form.parentContractId">
              {{ $t('contract.hasParent1') }}
              <a @click="$emit('OPEN_PARENT')">
                {{form.parentContract.contractName}}
              </a>
              {{ $t('contract.hasParent2') }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import FormFieldGraphSearch from '@/mixins/FormFieldGraphSearch'
import { mapState } from 'vuex'

export default {
  name: 'InfoSection',
  props: [
    'form',
    'validationModel',
    'errorMessages',
    'projects',
    'packages',
    'types',
    'areas',
    'isMultiCurrency'
  ],
  mixins: [FormFieldGraphSearch],
  data () {
    return {
      graphBasedFields: ['contractManager', 'packageManager', 'projectController']
    }
  },
  computed: {
    ...mapState({
      contracts: (state) => state.contracts
    }),
    potentialParentContractsList () {
      return this.contracts
        .filter(i => (this.form.project.id ? i.projectId === this.form.project.id : true) &&
        i.id !== this.form.id && i.parts.length < 2)
    },
    projectsList () {
      const mapProjectToEntries = (project) => {
        const name = project.code && project.code !== '' ? `${project.name} - ${project.code}` : project.name
        const projectAreas = (project.areas && project.areas.length) ? project.areas : [this.form.area]
        return projectAreas.map(i => ({
          ...project,
          area: i,
          value: { ...project },
          label: this.areas.length > 1 ? `${name} (${i.name})` : name
        }))
      }
      const list = this.projects.reduce((acc, curr) => [...acc, ...mapProjectToEntries(curr)], [])
      if (this.form.project && this.form.project.id && !list.some(i => i.id === this.form.project.id)) {
        list.push(...mapProjectToEntries(this.form.project))
      }
      return list.filter(i => {
        return !this.form.area || i.area.code === this.form.area.code
      })
    },
    packagesList () {
      const list = this.packages.reduce((acc, curr) => [
        ...acc,
        ...curr.areas.map(i => ({ ...curr, area: i }))
      ], []).filter(i => {
        return !this.form.area || i.area.code === this.form.area.code
      })
      if (this.form.package && !list.some(i => i.name === this.form.package)) {
        list.push({ name: this.form.package, area: this.form.area })
      }
      return list
    },
    typesList () {
      const list = this.types.reduce((acc, curr) => [
        ...acc,
        ...curr.areas.map(i => ({ ...curr, area: i }))
      ], []).filter(i => {
        return !this.form.area || i.area.code === this.form.area.code
      })
      if (this.form.contractType && !list.some(i => i.name === this.form.contractType)) {
        list.push({ name: this.form.contractType, area: this.form.area })
      }
      return list
    }
  },
  methods: {
    removeSubContractChip (index) {
      this.form.subContracts.splice(index, 1)
    },
    async handleSelectParent (v) {
      this.form.parentContractId = v ? v.id : null
    }
  },
  watch: {
    'form.project' (v) {
      if (v.name && this.form.parts.length && !this.form.parts[0].name) {
        this.form.parts[0].name = v.name
      }
    },
    'form.packageManager' (v, p) {
      if (v.displayName) {
        this.search.packageManager = v.displayName
      }
    },
    'form.projectController' (v, p) {
      if (v.displayName) {
        this.search.projectController = v.displayName
      }
    },
    'form.contractManager' (v, p) {
      if (v.displayName) {
        this.search.contractManager = v.displayName
      }
    }
  }
}
</script>
